/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Source/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Source({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/UnappliedPayment/Content/Source"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let entryTransactionUnappliedPaymentAppliedPaymentPaymentSourceValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.unapplied_payment.applied_payment.payment.source',
format: fromHelpers.getSource,
})
  return (<React.Fragment
>
<div
  data-testid="Source.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Source"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.transaction.unapplied_payment.applied_payment.payment.source"
 format="helpers.js getSource"
 text={entryTransactionUnappliedPaymentAppliedPaymentPaymentSourceValueData}
/>
</div>
{children}
</React.Fragment>)
}